import { render, staticRenderFns } from "./CartTab.vue?vue&type=template&id=4926435a&scoped=true&"
import script from "./CartTab.vue?vue&type=script&lang=js&"
export * from "./CartTab.vue?vue&type=script&lang=js&"
import style0 from "./CartTab.vue?vue&type=style&index=0&id=4926435a&lang=scss&scoped=true&"
import style1 from "./CartTab.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4926435a",
  null
  
)

export default component.exports